module.exports = __webpack_public_path__ + "static/img/formpic.96b417b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/formpic.jpg
// module id = 2uXL
// module chunks = 1